import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Pannello filtri standard per le griglie (piano ui-fixes, F0) — stessa resa del pannello
 * filtri della dashboard (accordion "Filtri di ricerca" aperto di default), corpo dei filtri
 * via `<ng-content>` e riga Azzera/Ricerca uniforme. I filtri contenuti sono sempre semplici
 * campi "inizia per": niente scelta di match mode (vedi `list-filter.util.ts`).
 */
@Component({
  selector: 'emed-filter-panel',
  standalone: false,
  templateUrl: './emed-filter-panel.component.html'
})
export class EmedFilterPanelComponent {
  @Input() title = 'Filtri di ricerca';

  @Output() reset = new EventEmitter<void>();
  @Output() search = new EventEmitter<void>();
}
